angular
	.module 'App.Repository'
	.factory 'AuthenticationRepository', ['$q', 'BaseRepository', ($q, BaseRepository) ->
		class AuthenticationRepository extends BaseRepository
			@resource = '/auth'
			@isRestricted = false

			clientName: 'backoffice'
			scopeName: 'backoffice'

			getLoginToken: (registerId = null) ->
				return @request 'POST', @getUrl('/login_token'), {register_id: registerId}, @createConfig(null, true)
					.then (response) =>
						return response.data

			getStatus: ->
				return @findById 'token'

			refreshToken: (refreshToken) ->
				if _.isEmpty refreshToken
					return $q.when({})

				payload =
					client_id: @clientName
					grant_type: 'refresh_token'
					refresh_token: refreshToken
					scope: @scopeName

				return @post 'token', payload

			getToken: (username, password, identifier = null) ->
				payload =
					username: username
					password: password
					client_id: @clientName
					grant_type: 'password'
					scope: @scopeName

				if identifier
					payload.identifier = identifier

				return @post 'token', payload

			getTokenByGoogleToken: (token, identifier = null) ->
				payload =
					google_token: token
					client_id: @clientName
					grant_type: 'google_token'
					scope: @scopeName

				if identifier
					payload.identifier = identifier

				return @post 'token', payload

			getTokenByMicrosoftToken: (token, identifier = null) ->
				payload =
					microsoft_token: token
					client_id: @clientName
					grant_type: 'microsoft_token'
					scope: @scopeName

				if identifier
					payload.identifier = identifier

				return @post 'token', payload

			getResourceToken: ->
				return @request 'POST', @getUrl('/resource_token'), {}, @createConfig(null, true)
					.then (response) =>
						return response.data

			revokeToken: ->
				@request 'DELETE', @getUrl('/token'), undefined, @createConfig(null, true)

			generateQrCode: (userId = null) ->
				configuration = @createConfig(null, true)
				configuration.responseType = 'blob'
				endpoint = '/qr_code'

				if userId?
					endpoint += '/' + userId

				return @request('GET', @getUrl(endpoint), undefined, configuration)
					.then (response) -> response.data

		return new AuthenticationRepository
	]
